import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function BookCalendlySection() {
  const sectionRef = useRef<HTMLElement>(null);
  const widgetRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      const existing = document.head.querySelector(
        'script[src="https://assets.calendly.com/assets/external/widget.js"]'
      );
      if (existing) {
        document.head.removeChild(existing);
      }
    };
  }, []);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        widgetRef.current,
        { opacity: 0, y: 20 },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
          },
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-[#FAF6F2] py-12 md:py-20 lg:py-24"
    >
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-5xl mx-auto">
        {/* Heading */}
        <div className="text-center mb-8 md:mb-12">
          <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-3">
            Instant Booking
          </p>
          <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#1A1A1A] mb-4 leading-tight">
            Book directly into
            <br />
            Mandie's calendar.
          </h2>
          <p className="font-body text-sm md:text-base text-[#4A4A4A] leading-relaxed max-w-xl mx-auto">
            Choose your session type, pick a time that works, and you are in. All times shown in your local timezone.
          </p>
        </div>

        {/* Calendly Widget */}
        <div ref={widgetRef}>
          <div
            className="calendly-inline-widget w-full rounded-lg overflow-hidden border border-[#C9A84C]/20 shadow-sm"
            data-url="https://calendly.com/mandieozee/15min"
            style={{ minWidth: '320px', height: '750px' }}
          />
        </div>

        {/* Bottom note */}
        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-3 text-sm font-body text-[#6A6A6A]">
            <i className="ri-lock-line text-[#C9A84C]" />
            <span>Your information is private and secure</span>
          </div>
        </div>
      </div>
    </section>
  );
}